import axios from "axios";
import { ClearSession, GetSession } from "../../Shared-ui/utils/Auth/AuthHelpers";
import { MetaBaseUrl } from "../../Constant/Setting";
import { useDispatch, useSelector } from "react-redux";
import { SetLogout } from "../../Shared-ui/Store/AuthReducer/AuthActions";
import { redirect } from "react-router-dom";
import { ShowError } from "../../Shared-ui/Store/MessageReducer/MsgActions";
import Store from "../../Shared-ui/Store";

const MetaInstance = axios.create({
    baseURL: MetaBaseUrl,
    headers: {
        'Content-Type': 'application/json',
    }
})

// Set up an Axios request interceptor to add the authorization token

MetaInstance.interceptors.request.use((config) => {
    const serviceToken = GetSession()
    if (serviceToken) {
        config.headers['Authorization'] = `Bearer ${serviceToken}`;
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

// Set up an Axios response interceptor to handle authentication errors and logout

MetaInstance.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
            ClearSession()
            window.location.href = "/logout"
        }
    }
    return Promise.reject(error)
})

// multipart instance ///

export const MetaMultipartInstance = axios.create({
    baseURL: MetaBaseUrl,
    headers: {
        'Content-Type': 'multipart/form-data',
    }
})

// Set up an Axios request interceptor to add the authorization token

MetaMultipartInstance.interceptors.request.use((config) => {
    const serviceToken = GetSession()
    if (serviceToken) {
        config.headers['Authorization'] = `Bearer ${serviceToken}`;
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

// Set up an Axios response interceptor to handle authentication errors and logout

MetaMultipartInstance.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response) {
        
        // if (error.response.status === 401 || error.response.status === 403) {
        //     ClearSession()
        //     window.location.href = "/logout"
        // }
        // else{
        //     const errorMessage = error.response.data?.detail?.response || "An error occurred";
        //     Store.dispatch(ShowError(errorMessage,3000)); 
        // }
    }
    return Promise.reject(error)
})


export default MetaInstance